<template>
  <div class="container mx-auto h-full py-5">
    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15" type="flex" justify="space-between">
          <el-col :span="5">
            <h3 class="text-l font-semibold">MIS EMPLEADOS</h3>
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchEmployee"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mt-5">
          <el-col :span="24">
            <el-table :data="filteredEmployees" stripe size="mini" ref="employeesTable">
              <el-table-column type="index" min-width="40" />
              <el-table-column label min-width="40">
                <template slot-scope="scope">
                  <img :src="photo(scope.row)" class="w-8 h-8 rounded-full" />
                </template>
              </el-table-column>
              <el-table-column label="Nombre" min-width="250">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.name1 }}
                    {{ scope.row.name2 }}
                    {{ scope.row.lastname1 }}
                    {{ scope.row.lastname2 }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Departamento" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.department.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Tipo de contrato" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractType.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="70">
                <template slot-scope="scope">
                  <span>{{ scope.row.status.name }}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="80" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button icon="el-icon-fa-ellipsis-v" size="small"></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <i class="el-icon-fa-eye"></i> Ver detalles
                      </el-dropdown-item>
                      <el-dropdown-item :divided="true" class="text-green-500 font-semibold">
                        <i class="el-icon-fa-bolt"></i> Acción de personal
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rawEmployees.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

import photo from "./../../../assets/imgs/picture.jpg";

export default {
  name: "EmployeesMine",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          myEmployees (where: { show: true } whereNot: { status: 3 }) {
            id
            name1
            name2
            lastname1
            lastname2
            image
            department {
              name
              parentDepartment {
                id
              }
            }
            contractType {
              name
            }
            status {
              name
            }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.myEmployees));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      searchEmployee: "",
      page: {
        size: 15,
        number: 1,
      },
      rawEmployees: [],
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
    },
    setData(data) {
      this.rawEmployees = data.filter(
        (d) =>
          d.department != null &&
          d.department.parentDepartment != null &&
          d.department.parentDepartment.id ==
            this.$store.state.user.employee.department.id
      );
    },
    photo() {
      return photo;
    },
  },
  computed: {
    filteredEmployees() {
      return this.rawEmployees
        .filter((employee) => {
          const search = this.searchEmployee.toLowerCase();
          const {
            name1,
            name2,
            lastname1,
            lastname2,
            department,
            position,
            contractType,
            status,
          } = employee;
          let fullName = "";
          fullName += R.isNil(name1) ? "" : `${name1} `;
          fullName += R.isNil(name2) ? "" : `${name2} `;
          fullName += R.isNil(lastname1) ? "" : `${lastname1} `;
          fullName += R.isNil(lastname2) ? "" : `${lastname2} `;

          return (
            fullName.toLowerCase().includes(search) ||
            department.name.toLowerCase().includes(search) ||
            position.name.toLowerCase().includes(search) ||
            contractType.name.toLowerCase().includes(search) ||
            status.name.toLowerCase().includes(search)
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
